(function () {
  let _refreshInFlight = false;
  let _refreshTimeoutId = null;

  function refreshFoxCart() {
    if (!window.FoxTheme || !window.FoxTheme.pubsub) return;
    if (_refreshInFlight) return;

    // Collect section IDs registered by CartDrawer / MainCart elements
    const sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
    );
    if (!sections.length) return;

    _refreshInFlight = true;

    // Safety: reset flag after 8s in case a fetch hangs and never resolves
    _refreshTimeoutId = setTimeout(function () {
      _refreshInFlight = false;
      _refreshTimeoutId = null;
    }, 8000);

    // B11: Single endpoint /cart.js?sections=ID,ID2 returns BOTH the
    // structured cart object AND the section HTML (Shopify Section
    // Rendering API). Pre-fix this snippet fired two parallel fetches:
    // /cart.js for the structured object, /cart?sections= for the HTML.
    // Consolidating to one call halves TTFB cost on slow networks and
    // matches the pattern already used by cart.js:recoverFromServer.
    fetch('/cart.js?sections=' + sections.join(','), {
      headers: { 'Content-Type': 'application/json' },
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart.js?sections= ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        // Validate response before publishing to avoid downstream TypeErrors
        if (!cart || typeof cart !== 'object' || !Array.isArray(cart.items)) {
          console.error('[Cart Refresh] Unexpected cart response format');
          return;
        }
        // /cart.js?sections= already populates cart.sections inline; no
        // merge step needed. Defensive default in case the endpoint omits
        // the field (legacy behavior or future API change).
        if (!cart.sections) cart.sections = {};
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
      })
      .catch(function (error) {
        // B10: Distinguish navigation-race (page unloading) from
        // CF-challenge-served (page still visible, HTML returned where
        // JSON expected). Pre-fix swallowed both as "navigation race",
        // hiding genuine CF challenges that left the drawer stale.
        const msg = (error && error.message) || String(error);
        const isAbortError = error && error.name === 'AbortError';
        const isNetworkError = /Failed to fetch/i.test(msg) || /NetworkError/i.test(msg);
        const isJsonParseError =
          (error && error.name === 'SyntaxError') || /Unexpected token/i.test(msg);

        // If the page is being unloaded, ignore everything: the user is
        // navigating away and the failed refresh is irrelevant.
        if (document.visibilityState !== 'visible') return;

        // Visible page + abort/network = nav-race against a click-followed-
        // by-checkout-link sequence. The browser aborted the fetches
        // before the response came back. Still safe to ignore.
        if (isAbortError || isNetworkError) return;

        // Visible page + JSON parse error = Cloudflare bot challenge
        // returned HTML where we expected JSON. The cart drawer will
        // remain stale until the next page load. Surface a warning so
        // the failure mode is at least diagnosable in the console
        // rather than hidden behind a silent return.
        if (isJsonParseError) {
          console.warn(
            '[Cart Refresh] CF challenge or non-JSON response served, cart drawer may be stale until next page load:',
            error
          );
          return;
        }
        console.error('[Cart Refresh] Failed to refresh cart:', error);
      })
      .finally(function () {
        if (_refreshTimeoutId) {
          clearTimeout(_refreshTimeoutId);
          _refreshTimeoutId = null;
        }
        _refreshInFlight = false;
      });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[aria-controls="CartDrawer"]')) {
      refreshFoxCart();
    }
  });
  window.CoraCartRefresh = { refresh: refreshFoxCart };
})();
